import React from "react";

import { Link } from "react-router-dom";

import BcsIcon from "../../icons/bcs-icon";
import CivilIcon from "../../icons/civil-icon";
import EconomyIcon from "../../icons/eco-icon";
import LawIcon from "../../icons/law-icon";
import MedicalIcon from "../../icons/medical-icon";
import MedicalTechIcon from "../../icons/med-tech-icon";

const CardItems = ({ cards, restClass }) => {
  const renderIcon = (id) => {
    switch (id) {
      case 1:
        return <MedicalIcon />;
      case 2:
        return <BcsIcon />;
      case 3:
        return <LawIcon />;
      case 4:
        return <EconomyIcon />;
      case 5:
        return <CivilIcon />;
      case 6:
        return <MedicalTechIcon />;
    }
  };

  const renderCard = (p = new Object()) => {
    return (
      <div className="card-item" key={p.id}>
        <Link to={`/mis/results/${p.id}`}>
          <div className="wrapper">
            <i>{renderIcon(p.id)}</i>
            <p>{p.name}</p>
          </div>
        </Link>
      </div>
    );
  };

  return cards ? (
    <div className={`card-items-area ${restClass}`}>
      {cards.map((card) => renderCard(card))}
    </div>
  ) : null;
};

export default CardItems;
